import { assign } from 'lodash';

import Store from 'lib/Store';
import { ActionTypes as UserActionTypes } from 'user/UserConstants';
import { ActionTypes } from 'auth/AuthConstants';

// Note: Flux stores are now a DEPRECATED pattern. See docs/GraphQL.md
class FeatureStore extends Store {
  getInitialState() {
    return {
      features: {},
    };
  }

  handleDispatch(action: any): void {
    switch (action.type) {
      case ActionTypes.AUTH_SUCCESS:
      case UserActionTypes.LOAD_USER: {
        const { user } = action;
        assign(this.state.features, user.getFeatures());
        this.emitChange();
        break;
      }
      default:
        break;
    }
  }

  hasFeature(feature: any): boolean {
    return !!this.state.features[feature];
  }
}

export default new FeatureStore();
